import * as Stitches from '@stitches/react';
import { styled } from '@gbm-tech/styles';

const HeadingBaseStyle: Stitches.CSS = {
  color: '$gray800',
};

const HeadingWeightMediumStyle: Stitches.CSS = {
  fontWeight: 500,
};

const HeadingWeightSemiBoldStyle: Stitches.CSS = {
  fontWeight: 600,
};

const HeadingWeightBoldStyle: Stitches.CSS = {
  fontWeight: 700,
};

export const HeadingH1Container = styled('h1', {
  fontSize: '3.6rem',
  lineHeight: '5.4rem',
  fontWeight: 400,

  ...HeadingBaseStyle,

  variants: {
    weight: {
      regular: {},

      medium: {
        ...HeadingWeightMediumStyle,
      },

      semibold: {
        ...HeadingWeightSemiBoldStyle,
      },

      bold: {
        ...HeadingWeightBoldStyle,
      },
    },
  },
});

export const HeadingH2Container = styled('h2', {
  fontSize: '3.2rem',
  lineHeight: '4.8rem',
  fontWeight: 400,

  ...HeadingBaseStyle,

  variants: {
    weight: {
      regular: {},

      medium: {
        ...HeadingWeightMediumStyle,
      },

      semibold: {
        ...HeadingWeightSemiBoldStyle,
      },

      bold: {
        ...HeadingWeightBoldStyle,
      },
    },
  },
});

export const HeadingH3Container = styled('h3', {
  fontSize: '2.4rem',
  lineHeight: '3.6rem',
  fontWeight: 400,

  ...HeadingBaseStyle,

  variants: {
    weight: {
      regular: {},

      medium: {
        ...HeadingWeightMediumStyle,
      },

      semibold: {
        ...HeadingWeightSemiBoldStyle,
      },

      bold: {
        ...HeadingWeightBoldStyle,
      },
    },
  },
});

export const HeadingH4Container = styled('h4', {
  fontSize: '2.0rem',
  lineHeight: '3.0rem',
  fontWeight: 400,

  ...HeadingBaseStyle,

  variants: {
    weight: {
      regular: {},

      medium: {
        ...HeadingWeightMediumStyle,
      },

      semibold: {
        ...HeadingWeightSemiBoldStyle,
      },

      bold: {
        ...HeadingWeightBoldStyle,
      },
    },
  },
});

export const HeadingH5Container = styled('h5', {
  fontSize: '1.6rem',
  lineHeight: '2.4rem',
  fontWeight: 400,

  ...HeadingBaseStyle,

  variants: {
    weight: {
      regular: {},

      medium: {
        ...HeadingWeightMediumStyle,
      },

      semibold: {
        ...HeadingWeightSemiBoldStyle,
      },

      bold: {
        ...HeadingWeightBoldStyle,
      },
    },
  },
});

export const HeadingH6Container = styled('h6', {
  fontSize: '1.4rem',
  lineHeight: '2.1rem',
  fontWeight: 400,

  ...HeadingBaseStyle,

  variants: {
    weight: {
      regular: {},

      medium: {
        ...HeadingWeightMediumStyle,
      },

      semibold: {
        ...HeadingWeightSemiBoldStyle,
      },

      bold: {
        ...HeadingWeightBoldStyle,
      },
    },
  },
});
